import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService, CommonPortalUrlService, UrlParamService } from 'gast-portal-ng';
import { TranslationService, Product } from 'gast-common-ng';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private commonPortalUrlService: CommonPortalUrlService,
        private translationService: TranslationService,
        private urlParamService: UrlParamService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // handling session id in url
        // this.urlParamService.saveSessionFromParamAndRemoveParam(route.queryParamMap);
        return this.http.get(this.commonPortalUrlService.getUserInfo(), { withCredentials: true }).pipe(
            map((response: any) => {
                if (response && response.name) {
                    this.authService.saveUserObjectInStorage(response.name, response.principal.longusername);
                    return true;
                } else {
                    console.log(`handle not logged in from route ${route.url}`);
                    return this.handleNotLoggedIn(state);
                }
            }),
            catchError((err) => {
                console.log('failed to retrieve user-info', err);
                return of(false);
            })
        );
    }

    private handleNotLoggedIn(state: RouterStateSnapshot) {
        this.authService.saveUserObjectInStorage(null, null);
        // don't redirect if in onset-study-home
        if (state.url.includes('onset-study-home')) {
            return false;
        } else {
            window.location.href = this.commonPortalUrlService.
                getPortalAccountLoginUrl(Product.ONSET, this.translationService);
        }
        return false;
    }
}
